<template>
  <ipo3-page>
    <template slot="title">審核新聞</template>
    <template slot="tools">
      <el-button type="primary" @click="goBack" icon="el-icon-back">返回新聞列表</el-button>
    </template>
    <template slot="page">
      <div class="commodity_edit">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="200px"
          class="demo-ruleForm"
        >
          <el-form-item label="新聞類別" prop="path">
            <el-radio-group v-model="ruleForm.type" @change="onChangeType">
              <el-radio-button label="1">普通新聞</el-radio-button>
              <el-radio-button label="2">視頻新聞</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label prop="video" v-show="ruleForm.type=='2'">
            <el-button v-if="!video" @click="showVideo" icon="el-icon-plus">選擇視頻</el-button>
            <el-card class="box-card" v-else>
              <div slot="header" class="clearfix">
                <span>{{video.name}}</span>
                <el-button style="float: right; padding: 3px 0" type="text" @click="showVideo">重新選擇</el-button>
              </div>
              <div class="brief">{{video.path}}</div>
            </el-card>
          </el-form-item>
          <el-form-item label="新聞分類" prop="type">
            <el-select
              v-model="ruleForm.category_id"
              placeholder="請選擇分類"
              style="margin-right:20px;"
            >
              <el-option
                v-for="item in categorys"
                :key="item.name"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
            <el-checkbox v-model="category_top" border label="分類置頂"></el-checkbox>
            <el-checkbox v-model="home_top" border label="首頁置頂"></el-checkbox>
          </el-form-item>
          <el-form-item label="新聞名稱" prop="title">
            <el-input v-model="ruleForm.title"></el-input>
          </el-form-item>

          <el-form-item label="新聞簡介" prop="describe">
            <el-input v-model="ruleForm.describe" type="textarea" :rows="2"></el-input>
          </el-form-item>

          <el-form-item label="縮略圖" prop="thumb">
            <el-radio-group v-model="ruleForm.thumb_type" size="mini">
              <el-radio label="0" border>正常</el-radio>
              <el-radio label="1" border>橫倒圖</el-radio>
              <el-radio label="2" border>封面圖</el-radio>
            </el-radio-group>
            <ipo3-upload @success="onSuccess" ref="upload"></ipo3-upload>
          </el-form-item>

          <el-form-item label="所屬比較" prop="compare_id">
            <el-tag
              type="warning"
              v-if="compare"
              closable
              @close="onDelete('compare')"
            >{{compare.name}}</el-tag>
            <el-button v-else class="button-new-tag" size="small" @click="showCompare">+ 添加比較</el-button>
          </el-form-item>

          <el-form-item label="新聞標籤" prop="hot_id">
            <template v-for="(item,index) in tags">
              <el-tag
                type="danger"
                closable
                @close="onDeleteTag(index,item)"
                :key="index"
                v-if="item.tag"
              >{{item.tag.name}}</el-tag>
            </template>
            <el-button class="button-new-tag" size="small" @click="showTags">+ 添加標籤</el-button>
          </el-form-item>
          <el-form-item label="新聞類型" prop="href">
            <el-radio-group v-model="ruleForm.ntype" size="mini">
              <el-radio label="0" border>正常</el-radio>
              <el-radio label="1" border>外鏈</el-radio>
            </el-radio-group>
            <el-input v-model="ruleForm.href" v-show="ruleForm.ntype=='1'" placeholder="請輸入連結"></el-input>
          </el-form-item>
          <el-form-item label="新聞詳情" prop="content">
            <tinymce :height="142" v-model="ruleForm.content" @on-ready="onReady" ref="tinymce"></tinymce>
          </el-form-item>

          <el-form-item label="來源" prop="source_id">
            <el-tag type="danger" v-if="source" closable @close="onDelete('source')">{{source.name}}</el-tag>
            <el-button v-else class="button-new-tag" size="small" @click="showSource">選擇來源</el-button>
          </el-form-item>

          <el-form-item label="作者" prop="author_id">
            <el-tag
              type="success"
              v-if="author"
              closable
              @close="onDelete('author')"
            >{{author.name}}</el-tag>
            <el-button v-else class="button-new-tag" size="small" @click="showAuthor">+ 添加作者</el-button>
          </el-form-item>

          <el-form-item label="是否熱門" prop="ishot">
            <el-switch v-model="ruleForm.ishot"></el-switch>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit" :loading="loading">提交</el-button>
            <el-button @click="resetForm('ruleForm')">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <author-edit ref="authorEdit" @selected="onSelectedAuthor"></author-edit>
      <compare-edit ref="compareEdit" @selected="onSelectedCompare"></compare-edit>
      <tags-edit ref="tagsEdit" @selected="onSelectedTags"></tags-edit>
      <video-edit ref="videoEdit" @selected="onSelectedVideo"></video-edit>
      <source-edit ref="sourceEdit" @selected="onSelectedSource"></source-edit>
    </template>
  </ipo3-page>
</template>
<script>
import authorEdit from "../news/views/author_edit";
import compareEdit from "../news/views/compare_edit";
import tagsEdit from "../news/views/tags_edit";
import videoEdit from "../news/views/video_edit";
import sourceEdit from "../news/views/source_edit";
import tinymce from "@/components/tinymce/index";
import { getToken } from "@/config/cache";
export default {
  name: "news-edit",
  components: {
    tinymce,
    authorEdit,
    compareEdit,
    tagsEdit,
    videoEdit,
    sourceEdit
  },

  data() {
    return {
      upload_url: `${this.$config.api_url}admin/upload`,
      id: null,
      edit: false,
      msg: "",
      categorys: [],
      tags: [],
      video: null,
      author: null, //作者
      compare: null, //比较
      hots: null, //热话
      source: null, //来源
      loading: false,
      category_top: false,
      home_top: false,
      ruleForm: {
        name: "",
        describe: "",
        content: "",
        thumb: "",
        category_id: "",
        author_id: "",
        ishot: true,
        thumb_type: "0",
        type: "1",
        ntype: "0",
        href:'',
      },
      rules: {
        name: [{ required: true, message: "请输入商品名稱", trigger: "blur" }],
        price: [{ required: true, message: "请输入商品价格", trigger: "blur" }]
      }
    };
  },
  computed: {
    headers() {
      const token = getToken(); //获取本地token
      return { Authorization: token };
    }
  },
  mounted() {
    this.getCategory();
    if (this.$route.params.id !== undefined) {
      this.edit = true;
      this.id = this.$route.params.id;
      this.getData(this.$route.params.id);
    }
  },
  methods: {
    onChangeType(value) {
      console.log("value:", value);
      if (value == 1) {
        this.video = null;
      }
    },
    onChangeHT(value) {
      this.ruleForm.home_top = value;
      console.log("ht:", value);
    },
    onChangeCT(value) {
      this.ruleForm.category_top = value;
      console.log("ct:", value);
    },
    onSelectedVideo(value) {
      this.video = value;
    },
    onDeleteTag(index, value) {
      this.tags.splice(index, 1);
     
    },
    onDelete(name) {
      if (name === "author") {
        this.author = null;
      } else if (name === "compare") {
        this.compare = null;
      } else if (name === "source") {
        this.source = null;
      }
    },
    showAuthor() {
      this.$refs["authorEdit"].show();
    },
    onSelectedAuthor(value) {
      this.author = value;
    },
    onSelectedCompare(value) {
      this.compare = value;
    },
    onSelectedTags(value) {
      
      if (value.selected) {
        this.tags.push({ tag: value });
      } else {
        for (var i = 0; i < this.tags.length; i++) {
          var item = this.tags[i];
          if (item.tag.id === value.id) {
            this.tags.splice(i, 1);
            return;
          }
        }
      }
    },
    onSelectedSource(value) {
      this.source = value;
    },
    showSource() {
      this.$refs["sourceEdit"].show();
    },
    showCompare() {
      this.$refs["compareEdit"].show();
    },
    showTags() {
      this.$refs["tagsEdit"].show(this.tags);
    },
    showVideo() {
      this.$refs["videoEdit"].show();
    },
    handleClose(tag, index) {
      if (index == 0) {
        this.colourTags.splice(this.colourTags.indexOf(tag), 1);
      } else {
        this.sizeTags.splice(this.sizeTags.indexOf(tag), 1);
      }
    },
    onSuccess(image) {
      this.ruleForm.thumb = image.path;
    },
    getCategory() {
      this.$http.get("/admin/category", { size: 100 }).then(res => {
        this.categorys = res.data.data;
      });
    },
    onReady() {
      if (this.ruleForm.detail) {
        this.$refs.tinymce.setContent(this.ruleForm.detail.content);
      }
    },
    getData(id) {
      var self = this;
      this.$http.get("/admin/member/news_detail", { id: id }).then(res => {
        // self.ruleForm = res.data;
        // self.ruleForm.thumb_type = self.ruleForm.thumb_type + "";
        // self.ruleForm.ntype = self.ruleForm.ntype + "";
        // self.ruleForm.ishot = self.ruleForm.ishot == 0 ? false : true;
        // self.category_top = self.ruleForm.category_top == 0 ? false : true;
        // self.home_top = self.ruleForm.home_top == 0 ? false : true;
        self.ruleForm.title = res.data.title;
        self.ruleForm.href = res.data.href;
        self.ruleForm.content = res.data.content;
        self.ruleForm.type = parseInt(res.data.type)+1;
        self.video = res.data.video;
        let images = res.data.image_ids;

        if(images && images.length>0)
        {
          self.$refs.upload.setImage({
            url: images[0],
            name: "news.jpg"
          });
          self.ruleForm.thumb = images[0];
        }
        
        // self.hots = self.ruleForm.hots;
        // self.compare = self.ruleForm.compare;
        // self.video = self.ruleForm.video;
        // self.source = self.ruleForm.source;
        // self.author = self.ruleForm.author;
        // self.tags = self.ruleForm.tags;
        if (self.ruleForm.content) {
          self.$refs.tinymce.setContent(self.ruleForm.content);
        }
      });
    },

    onSubmit() {
      
      let params = Object.assign({}, this.ruleForm);
      params.compare_id = this.compare ? this.compare.id : 0;
      params.author_id = this.author ? this.author.id : 0;
      params.hot_id = this.hots ? this.hots.id : 0;
      params.video_id = this.video ? this.video.id : 0;
      params.source_id = this.source ? this.source.id : 0;
      params.ishot = params.ishot ? 1 : 0;
      params.category_top = this.category_top ? 1 : 0;
      params.home_top = this.home_top ? 1 : 0;
      if(params.ntype=="0")
      {
        params.href="";
      }
      if(params.href=="")
      {
        params.ntype = "0";
      }
      console.log("tags:", this.tags);
      let ids = this.tags.map(element => {
        if (element.tag) {
          return element.tag.id;
        }
      });
      this.loading = true;
      params.tag_ids = ids.join(",");
      let self = this;
      this.$http.post("/admin/news/edit", params).then(res => {
        self.loading = false;
        if (res.code == 200) {
          let news = res.data.news;
          if(news !== null)
          {
            self.$http.post("/admin/member/news_examine",{id:self.id,news_id:news.id}).then(rres=>{
              console.log("examine:",rres);
            });
          }
          self.goBack();
        } else {
          self.$message.error("編輯失败");
        }
      });
    },
    
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
};
</script>
<style lang='less'>
.commodity_edit {
  width: 800px;
  text-align: left;
  .el-tag + .el-tag {
    margin-left: 10px;
  }
  .button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }
  .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
  }
}
// .el-form {
//   width: 800px;
//   .el-form-item {
//     .el-form-item__content {
//       text-align: left;
//     }
//   }
// }
</style>